import React from 'react'
import NotificationAutoInterUpdator from '../../../../NotificationAutoInterUpdator'
import NotificationViewModel from '../../../../NotificationViewModel'
import i18next from 'i18next'

const SubDepDeletionNotif = (props) => {
  const { notification, project } = props
  NotificationAutoInterUpdator(props)
  const lang = i18next.language
  const rtl = lang === 'ar'
  return (
    <NotificationViewModel
      {...props}
      learningSectionContent={''}
      notificationBody={
        <section style={{ width: '100%' }}>
          {rtl
            ? `لقد تم إغلاق القسم الفرعى الخاص بك`
            : 'A sub-department has been closed'}{' '}
          {notification?.accompaniedData?.subdepartment?.Name}{' '}
          {rtl ? `فى` : `in`} {project?.ProjectName}
        </section>
      }
      buttonsArray={[]}
    />
  )
}

export default SubDepDeletionNotif
